import Table from "@/v2-backoffice-client/components/table"
import { useLayerCountsQuery } from "@/v2-backoffice-client/layer/counts/layer.counts.query"
import {
  LAYER_ENABLED_STATUS_CODE,
  LAYER_DISABLED_STATUS_CODE,
} from "@/v2-backoffice-client/layer/counts/layer.counts.constants"

export type LayerStatusFilterChipsProps = {
  isEnabled: boolean | undefined
  onChange(isEnabled: boolean | undefined): void
}

/**
 * Status-filter chips for the layers table (All / Enabled / Disabled) with
 * live counts. Self-fetching leaf: owns the counts query so LayerTable
 * doesn't need it just to label three pills.
 */
function LayerStatusFilterChips(props: LayerStatusFilterChipsProps) {
  const { isEnabled, onChange } = props

  const { data: countsData } = useLayerCountsQuery()
  const counts = countsData?.getLayerCounts

  const defaultValue =
    isEnabled === undefined
      ? null
      : isEnabled
        ? LAYER_ENABLED_STATUS_CODE
        : LAYER_DISABLED_STATUS_CODE

  return (
    <Table.StatusFilter
      defaultValue={defaultValue}
      onChange={(value) => {
        onChange(
          value === null ? undefined : value === LAYER_ENABLED_STATUS_CODE,
        )
      }}
    >
      <Table.StatusFilter.Option value={null} count={counts?.Total}>
        All
      </Table.StatusFilter.Option>

      <Table.StatusFilter.Option
        variant="success"
        value={LAYER_ENABLED_STATUS_CODE}
        count={counts?.Enabled}
      >
        Enabled
      </Table.StatusFilter.Option>

      <Table.StatusFilter.Option
        variant="destructive"
        iconSrc="block"
        value={LAYER_DISABLED_STATUS_CODE}
        count={counts?.Disabled}
      >
        Disabled
      </Table.StatusFilter.Option>
    </Table.StatusFilter>
  )
}

export default LayerStatusFilterChips
